import { Button, Text, Tooltip } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_CANVAS_TITLE, useChatStore } from '@mygpt/app/chat';
import { useMedia } from '@mygpt/app/utils';

export const CanvasToggleButton = ({
  messageId,
  canvas_url,
  canvas_title,
  isMobile: isMobileProp,
  compact = false,
}: {
  messageId: string;
  canvas_url?: string;
  canvas_title?: string;
  isMobile?: boolean;
  compact?: boolean;
}) => {
  const { shownCanvas, setShownCanvas, clearShownCanvas, removeShownCanvas, addShownCanvas } = useChatStore();
  const { t } = useTranslation();
  const isCanvasOpened = Object.keys(shownCanvas).length > 0;
  const { isMobile: isDeviceMobile } = useMedia();
  const isMobile = isMobileProp !== undefined ? isMobileProp : isDeviceMobile;

  if (!canvas_url) return null;

  const handleClick = () => {
    // 如果点击了相同的canvas, 则关闭canvas
    if (isCanvasOpened && shownCanvas[messageId]) {
      if (isMobile) {
        removeShownCanvas(messageId);
      } else {
        clearShownCanvas();
      }
      return;
    }

    // 如果点击了不同的canvas, 则展示新的canvas
    if (isMobile) {
      addShownCanvas(messageId, canvas_url, canvas_title || DEFAULT_CANVAS_TITLE);
    } else {
      setShownCanvas(messageId, canvas_url, canvas_title || DEFAULT_CANVAS_TITLE);
    }
  };

  // 移动端使用按钮
  if (isMobile) {
    return (
      <div className={compact ? 'flex flex-col items-center flex-1' : ''}>
        <Tooltip label={t('canvas.toggle')} withArrow>
          <Button
            size="sm"
            variant="default"
            onClick={handleClick}
            className="border-[#E4E7EC] rounded-md h-10"
            fullWidth={!compact}
            leftSection={<IconEye size={18} color="gray" />}
          >
            <Text size="xs" color="gray.6">
              {t('canvas.toggle')}
            </Text>
          </Button>
        </Tooltip>
      </div>
    );
  }

  // 桌面端保持原样
  return (
    <Tooltip label={t('canvas.toggle')} withArrow>
      <Button size="sm" variant="subtle" onClick={handleClick} leftSection={<IconEye size={18} color="gray" />}>
        <Text size="xs" color="gray.6">
          {t('canvas.toggle')}
        </Text>
      </Button>
    </Tooltip>
  );
};
